module.exports = __webpack_public_path__ + "fonts/7696b73844851202a5b4f4c78e4ca8d4.svg";